import { css, type Theme } from '@emotion/react';

import WaveOne from '../../../../../assets/images/WaveOne.raw.svg';
import WaveThree from '../../../../../assets/images/WaveThree.raw.svg';
import WaveTwo from '../../../../../assets/images/WaveTwo.raw.svg';
import { CARD_VARIANTS } from '../constants';

export const getColors = (theme: Theme, variant: CARD_VARIANTS) => {
  const colorGroup = variant.toLowerCase();

  if (variant === CARD_VARIANTS.NEUTRAL)
    return {
      background: theme.colors.gray[0],
      waveOne: theme.colors.gray[0],
      waveTwo: theme.colors.gray[0],
      waveThree: theme.colors.gray[0],
      content: theme.colors.gray[0],
    };

  return {
    background: theme.colors[colorGroup][25],
    waveOne: theme.colors[colorGroup][200],
    waveTwo: theme.colors[colorGroup][100],
    waveThree: theme.colors[colorGroup][50],
    content: theme.colors.gray[700],
  };
};

export const container = (theme: Theme, variant: CARD_VARIANTS) => css`
  position: relative;
  border-top: 1px solid ${theme.colors.gray[100]};
  padding: 10px;
  background-color: ${getColors(theme, variant).background};

  border-radius: 0 0 4px 4px;

  display: flex;
  align-items: flex-start;
  gap: 10px;

  z-index: 0;
  overflow: hidden;
`;

export const waveThree = (theme: Theme, variant: CARD_VARIANTS) => css`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 400px;
  height: 60px;
  background-color: ${getColors(theme, variant).waveThree};
  mask-image: url(${WaveThree});
  background-repeat: no-repeat;
  mask-size: 100% 100%;
  opacity: 0.3;
  z-index: -3;
`;

export const waveTwo = (theme: Theme, variant: CARD_VARIANTS) => css`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 380px;
  height: 50px;
  background-color: ${getColors(theme, variant).waveTwo};
  mask-image: url(${WaveTwo});
  background-repeat: no-repeat;
  mask-size: 100% 100%;
  opacity: 0.3;
  z-index: -2;
`;

export const waveOne = (theme: Theme, variant: CARD_VARIANTS) => css`
  position: absolute;
  bottom: -1px;
  right: 0;
  width: 300px;
  height: 21px;
  background-color: ${getColors(theme, variant).waveOne};
  mask-image: url(${WaveOne});
  background-repeat: no-repeat;
  mask-size: 100% 100%;
  opacity: 0.3;
  z-index: -1;
`;
